module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contenedor-lista"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Lista de reclamaciones")]), _c('div', {
    staticClass: "filtro-estados"
  }, _vm._l((_vm.estados), function(o) {
    return _c('div', {
      staticClass: "option",
      class: {
        'fc-empresa': o === _vm.estado, 'selected': o === _vm.estado
      },
      on: {
        "click": function($event) {
          _vm.estado = o
        }
      }
    }, [_vm._v(_vm._s(o))])
  })), (_vm.lista.length !== 0) ? _c('table', {
    staticClass: "table is-striped is-bordered"
  }, [_vm._m(0), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o) {
    return _c('tr', {
      key: o.preimpreso,
      staticClass: "row-table"
    }, [_c('td', [_c('span', {
      staticClass: "name"
    }, [_vm._v(_vm._s(o.preimpreso))])]), _c('td', [_c('span', [_vm._v(_vm._s(o.descripcionLocal))]), _c('br'), _c('span', {
      staticClass: "small"
    }, [_vm._v(_vm._s(o.direccionLocal))])]), _c('td', [_c('span', [_vm._v(_vm._s(o.nombre))]), _c('br'), _c('span', {
      staticClass: "small"
    }, [_vm._v(_vm._s(o.email))]), _c('br'), _c('span', {
      staticClass: "small"
    }, [_vm._v(_vm._s(o.telefono))])]), _c('td', [_vm._v(_vm._s(o.fecha))]), _c('td', {
      staticClass: "center td-acciones"
    }, [_c('button', {
      staticClass: "button bd-color-empresa fc-empresa",
      on: {
        "click": function($event) {
          _vm.verPdf(o)
        }
      }
    }, [_vm._v("Ver detalles")]), (o.estado === 1) ? _c('button', {
      staticClass: "button is-empresa button-responder",
      on: {
        "click": function($event) {
          _vm.$emit('selected', o)
        }
      }
    }, [_vm._v("Responder")]) : _vm._e()])])
  }))]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Numero")]), _c('th', [_vm._v("Local")]), _c('th', [_vm._v("Cliente")]), _c('th', [_vm._v("Fecha")]), _c('th', [_vm._v("Acciones")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d89af84","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component-lista-reclamaciones.vue
// module id = 77
// module chunks = 0